module.exports = __webpack_public_path__ + "img/3_145.5eb85e8c.png";